import React from "react";

interface ClarificationStatsProps {
  pending: number;
  resolved: number;
  notResolved: number;
  total: number;
}

const ClarificationStats: React.FC<ClarificationStatsProps> = ({
  pending,
  resolved,
  notResolved,
  total,
}) => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.cardContent}>
          <div style={styles.cardInfo}>
            <div style={styles.cardLabel}>Pendientes</div>
            <div style={styles.cardValue}>{pending}</div>
          </div>
          <div style={styles.cardIcon}>
            <i className="fas fa-clock" style={styles.icon}></i>
          </div>
        </div>
      </div>

      <div style={{ ...styles.card, ...styles.cardSuccess }}>
        <div style={styles.cardContent}>
          <div style={styles.cardInfo}>
            <div style={styles.cardLabel}>Resueltas</div>
            <div style={{ ...styles.cardValue, color: "#059669" }}>
              {resolved}
            </div>
          </div>
          <div style={styles.cardIcon}>
            <i
              className="fas fa-check-circle"
              style={{ ...styles.icon, color: "#059669" }}
            ></i>
          </div>
        </div>
      </div>

      <div style={{ ...styles.card, ...styles.cardDanger }}>
        <div style={styles.cardContent}>
          <div style={styles.cardInfo}>
            <div style={styles.cardLabel}>No Resueltas</div>
            <div style={{ ...styles.cardValue, color: "#dc2626" }}>
              {notResolved}
            </div>
          </div>
          <div style={styles.cardIcon}>
            <i
              className="fas fa-times-circle"
              style={{ ...styles.icon, color: "#dc2626" }}
            ></i>
          </div>
        </div>
      </div>

      <div style={{ ...styles.card, ...styles.cardPrimary }}>
        <div style={styles.cardContent}>
          <div style={styles.cardInfo}>
            <div style={styles.cardLabel}>Total</div>
            <div style={{ ...styles.cardValue, color: "#2563eb" }}>{total}</div>
          </div>
          <div style={styles.cardIcon}>
            <i
              className="fas fa-list"
              style={{ ...styles.icon, color: "#2563eb" }}
            ></i>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "1rem",
    margin: "1.5rem",
  },
  card: {
    background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
    transition: "all 0.3s ease",
    border: "1px solid rgba(255, 255, 255, 0.5)",
  },
  cardSuccess: {
    background: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
  },
  cardDanger: {
    background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
  },
  cardPrimary: {
    background: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
  },
  cardContent: {
    padding: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  cardInfo: {
    flex: 1,
  },
  cardLabel: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#6b7280",
    marginBottom: "0.5rem",
  },
  cardValue: {
    fontSize: "2rem",
    fontWeight: 700,
    color: "#f59e0b",
    lineHeight: 1,
  },
  cardIcon: {
    fontSize: "2.5rem",
    opacity: 0.8,
  },
  icon: {
    color: "#f59e0b",
  },
};

export default ClarificationStats;
